import { useState } from 'react';
import { useSession } from '../lib/session';
import { useHub } from './context';
import { BUNGIE_NOTE } from './ui';

/**
 * A page that needs a Guardian, with nobody signed in or looked up: sign in, or look up any Guardian by Bungie name
 * (public data, as the app's Tracker setting). On the front page (no `need`) it is only a slim strip, as Braytech's
 * "Select Your Character" bar, so the page itself comes first.
 */
export default function Landing({ need }: { need?: string }) {
  const session = useSession();
  const h = useHub();
  const [name, setName] = useState('');
  const lookup = (
    <form className="g-lookup" onSubmit={(e) => { e.preventDefault(); if (name.trim()) void h.lookup(name); }}>
      <input className="g-input" placeholder="Bungie name, like Name#1234" value={name} onChange={(e) => setName(e.target.value)} aria-label="Bungie name" />
      <button className="btn" type="submit" disabled={!name.trim()}>Look up</button>
    </form>
  );
  if (!need) {
    return (
      <div className="g-strip">
        <p>Destiny 2 rotations, Xûr, item look-up and maps for everyone. <span className="g-text2">Sign in to add your own vault, gear and progress.</span></p>
        <div className="g-strip-actions">
          {lookup}
          <button className="btn primary" onClick={session.signIn} type="button">Sign in with Bungie</button>
        </div>
        {h.lookupError && <p className="g-warn">{h.lookupError}</p>}
      </div>
    );
  }
  return (
    <div className="g-landing g-card">
      <h2>Sign in with Bungie to see this</h2>
      <p className="g-text2">This page shows your own Guardian. Sign in with Bungie, on Bungie's own page (this site never sees your password), or look up any Guardian by name.</p>
      <div className="g-landing-row">
        <button className="btn primary" onClick={session.signIn} type="button">Sign in with Bungie</button>
      </div>
      {lookup}
      {h.lookupError && <p className="g-warn">{h.lookupError}</p>}
      <p className="g-dim small">{BUNGIE_NOTE}</p>
    </div>
  );
}
